import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { PainScoreCatAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-pain-score-cat-slot',
    templateUrl: './pain-score-cat-slot.component.html',
    styleUrl: './pain-score-cat-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PainScoreCatSlotComponent implements SheetSlotComponentBase {

	action!: PainScoreCatAction;
	value!: string | null;

	@Input('action') set updateAction(action: PainScoreCatAction | null) {
		this.action = action as PainScoreCatAction;
		this.value = this.action.totalScore?.toString() ?? null;
	}

	constructor() {
	}
}